module.exports = __webpack_public_path__ + "img/but_login_test.a3f40707.png";